var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 2.16634C4.77801 2.16634 2.16634 4.77801 2.16634 7.99967C2.16634 11.2213 4.77801 13.833 7.99967 13.833C11.2213 13.833 13.833 11.2213 13.833 7.99967C13.833 4.77801 11.2213 2.16634 7.99967 2.16634ZM1.83301 7.99967C1.83301 4.59392 4.59392 1.83301 7.99967 1.83301C11.4054 1.83301 14.1663 4.59392 14.1663 7.99967C14.1663 11.4054 11.4054 14.1663 7.99967 14.1663C4.59392 14.1663 1.83301 11.4054 1.83301 7.99967Z",
    stroke: "#1877F2",
    strokeOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42256 6.33414C7.2382 6.65285 6.83038 6.76176 6.51167 6.5774C6.19296 6.39303 6.08406 5.98522 6.26842 5.66651C6.61322 5.07045 7.25932 4.66699 8.00045 4.66699C9.10501 4.66699 10.0004 5.56242 10.0004 6.66699C10.0004 7.39881 9.55152 7.99631 9.00045 8.33366C8.55779 8.60463 8.83378 9.33366 7.9987 9.33366C7.63051 9.33366 7.33203 9.03518 7.33203 8.66699C7.33203 8.64359 7.33324 8.62046 7.33559 8.59768C7.35408 8.2451 7.5113 7.95822 7.68247 7.74962C7.86325 7.52931 8.10093 7.34947 8.28268 7.24142C9.29382 6.64032 8.06056 5.41059 7.42256 6.33414ZM7.9987 10.0003C7.63051 10.0003 7.33203 10.2988 7.33203 10.667C7.33203 11.0352 7.63051 11.3337 7.9987 11.3337C8.36689 11.3337 8.66536 11.0352 8.66536 10.667C8.66536 10.2988 8.36689 10.0003 7.9987 10.0003Z",
    fill: "#94C0F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.e56629929a14c3a7cd49274245053a19.svg";
export { ForwardRef as ReactComponent };